// import { DialogService } from 'ng2-bootstrap-modal';
import { ConfirmdeleteComponent } from './../../service/confirmdelete/confirmdelete.component';
import { models } from '../../service/sector.model';
import { ManageService } from './../../service/manage.service';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit } from '@angular/core';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-models',
  templateUrl: './models.component.html',
  styleUrls: ['./models.component.css']
})
export class ModelsComponent implements OnInit {
  bsModalRef: BsModalRef;
  public Model:any = {
    'SectorName': ''
  };
  modellist = [];
  result:any = {};
  sectorlist:any = [];

  ModelName: string;
  Description: string;
  ThresholdProbability: string;
  SectorName: string;

  constructor(private getmodels: DBConnectorService,
    private manage: ManageService,
    private _dialogService: BsModalService,
    private loggedInGuard: LoggedInGuard) {

  }


  getmodellist() {
    if (this.loggedInGuard.isSessionValid()) {
      this.getmodels.getallmodels()
        .subscribe(res => {
          this.modellist = res;

        });
    }
  }
  getsectorlist() {
    if (this.loggedInGuard.isSessionValid()) {
      this.getmodels.getsectors()
        .subscribe(res => this.sectorlist = res);
    }
  }

  ModelCreate() {
    if (this.loggedInGuard.isSessionValid()) {

      this.Model.ModelName = this.ModelName;
      this.Model.Description = this.Description;
      this.Model.ThresholdProbability = this.ThresholdProbability;
      this.Model.SectorName = this.SectorName;

      this.manage.createModel(this.Model)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            this.getmodellist();
          });
    }
  }

  showConfirm(mode: models) {
    this.bsModalRef = this._dialogService.show(ConfirmdeleteComponent);
    this.bsModalRef.content.event.subscribe(isConfirmed => {
      if(isConfirmed) 
        this.ModelDelete(mode);
    })
    // let disposable = this.dialogService.addDialog(ConfirmdeleteComponent, {
    //   // title: 'Confirm title',
    //   // message: 'Confirm message'
    // })
    //   .subscribe((isConfirmed) => {
    //     //We get dialog result
    //     if (isConfirmed) {
    //       this.ModelDelete(mode);
    //     }
    //     else {
    //       // alert('declined');
    //     }
    //   });
    //We can close dialog calling disposable.unsubscribe();
    //If dialog was not closed manually close it by timeout
    // setTimeout(() => {
    //   disposable.unsubscribe();
    // }, 10000);
  }

  ModelDelete(mode: models) {
    if (this.loggedInGuard.isSessionValid()) {
      this.manage.deleteModel(mode)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            this.getmodellist();
          });
    }
  }

  ModelEdit(mode: models) { }

  ngOnInit() {
    this.getmodellist();
    this.getsectorlist();
  }

}
